import * as React from "react";
import SelectComponent from "../ui/select/SelectComponent";
import Appointment from "../../model/appointment/Appointment";
import DateUtils from "../../utils/DateUtils";

export default class AppointmentPicker extends SelectComponent<Appointment> {

	matchFilter(element: Appointment, filter: string): boolean {
		return this.elementToString(element).indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: Appointment): string {
		return element.id;
	}

	elementToString(element: Appointment) {
		return `${element.dateTime.format(DateUtils.DATE_TIME_FORMAT)} - ${element.endDateTime.format(
			DateUtils.DATE_TIME_FORMAT)}`;
	}
}
